{
  "name": "quality-assurance",
  "hostname": "qa.safarilaw.com",
  "default": null,
  "development": true,
  "production": false,
  "applicationName": "Safari SOP",
  "sourceVersion": "925a778bb7dffaa61f92ef338a15bc52cd99c3db",
  "errors": {
    "numRetries": 3
  },
  "urls": {
    "apiRootCoManage": "https://@.qa.safarilaw.com/_api/comanage/",
    "apiRootLpms": "https://@.qa.safarilaw.com/_api/lpms/",
    "apiRootSquirrel": "https://@.qa.safarilaw.com/_api/squirrel/",
    "apiRootRms": "https://@.qa.serveport.com/_api/rms/",
    "serveportPortalRoot": "https://app.qa.serveport.com/serve/",
    "serveportAgencyPortalUrl": "https://agency.qa.serveport.com/"
  },
  "auth0": {
    "authorityRoot": "safarilaw-qa.auth0.com",
    "clientId": "vvR20W2VPrnRs1aVZmukIkNCiUCdDOWm",
    "useLocalStorageCache": false
  },
  "auth": {
    "inactivityTimeout": 15,
    "inactivityWarning": 2
  },
  "statusApp": {
    "apiRootUrl": "https://@.qa.safarilaw.com/_api/maintenance/",
    "code": "o33J6l83lG-HUvterNqfuIAfeJcqvqnNN2s-bvpGqEtvAzFuTio3nQ==",
    "cacheDurationInMinutes": 5
  },
  "featureFlags": {
    "demoPreviews": true,
    "devTools": true,
    "devExceptions": true,
    "enableMatterSubtypePicklistSettingsEditing": true,
    "showMatterSubtypePicklistSettings": true,
    "showCustomPicklistSettings": true,
    "enableCustomPicklistSettingsEditing": true,
    "inputRelativeValidation": true,
    "showServiceAccountSettings": true,
    "notificationBellEnabled": true,
    "enableCloneMatter": true,
    "enableServeportPortalEdit": true,
    "enableServiceOfProcessBusinessHours": true,
    "enableBlackMamba": true,
    "enableFederalBenefitExemptionStatus": true,
    "enableEmailFileViewer": true,
    "enableNonPdfIntakeUpload": true,
    "enablePdfTemplates": false,
    "enableTaskGroups": false
  },
  "loggers": {
    "elmah": {
      "apiKey": "752d3d5a800541cd8dd1b5d747cc188a",
      "logId": "7d177c2f-01cf-434e-814e-f8d3ef1e7e1b"
    },
    "appInsights": {
      "connectionString": "InstrumentationKey=15af416b-734a-4560-80d6-6f617366802c;IngestionEndpoint=https://eastus-0.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=af1f3b04-48e3-49b5-ba59-7ccd602f0363"
    }
  },
  "uiSettings": {
    "hasNavbar": true,
    "list": {
      "maxCountInMemory": 10000,
      "pageSize": 20
    },
    "maxSubtypesToShowInDropdown": 0,
    "updatePollFrequency": 3600,
    "showSwWarning": true,
    "richTextEditor": {
      "initializationTimeoutInMs": 2000
    },
    "file": {
      "previewDialogTimeLimitInSeconds": 5,
      "downloadTarget": "_self",
      "tusUploadLimitInMb": 0,
      "maxCorrespondenceSizeAttachmentInMb": 20
    },
    "reports": {
      "key": "Z70R-XG6J5I-274219-0W0Y0F-734Y3H-5I460R-0H445W-4F6S27-2G5S1J-4P291I-2E5N"
    },
    "ckeditor": {
      "key": "eyJhbGciOiJFUzI1NiJ9.eyJleHAiOjE4MjQ1OTUxOTksImp0aSI6ImQ1NWI1Mjc0LTg0YTUtNDZmZC04N2E0LWFlYzZiNmUwOGE3YyIsImRpc3RyaWJ1dGlvbkNoYW5uZWwiOlsic2giLCJkcnVwYWwiXSwid2hpdGVMYWJlbCI6dHJ1ZSwibGljZW5zZVR5cGUiOiJkZXZlbG9wbWVudCIsImZlYXR1cmVzIjpbIkRSVVAiXSwidmMiOiJlOGFlNTQ4NCJ9.oqxsFLsEfR0gmD4JFvTS5TgzpQ4IJ3BwZirvcVT55JzMJxksQcQ8x2UCqNJjtU_ULe3AhCaYNtLrpgJudG_FeQ"
    }
  },
  "signalR": {
    "hubs": [
      {
        "api": "lpms",
        "name": "matters",
        "url": "signalr/matters"
      },
      {
        "api": "lpms",
        "name": "correspondences",
        "url": "signalr/correspondences"
      },
      {
        "api": "lpms",
        "name": "notifications",
        "url": "signalr/notifications"
      },
      {
        "api": "lpms",
        "name": "intake-files",
        "url": "signalr/intake-files"
      }
    ]
  }
}
